import React from 'react'
import { Cart } from '../../assets'
import { t } from '../../miscellaneous/language'

const CompleteStatus = ({updateStaticStatus}) => {
    return (
        <div className="after-order-card">
            <div className="after-order-status-container">
                <span className="after-order-title">{t.text.completeStatus.title}</span>
                <span className="after-order-desc">{t.text.completeStatus.desc}</span>
            </div>
            <div className="after-order-icon-container">
                <Cart id="cart-medium-icon" />
            </div>
        </div>
    )
}

export default CompleteStatus
